import { z } from 'zod';

export const publicRegistrationMemberSchema = z.object({
  firstName: z.string().trim().min(1, 'First name is required').max(100),
  lastName: z.string().trim().min(1, 'Last name is required').max(100),
  ageGroup: z.enum(['adult', 'teen', 'youth', 'child', 'infant']),
  relationship: z.string().trim().min(1, 'Relationship is required').max(100),
  dietaryRestrictions: z.array(z.string()).max(10).optional().default([]),
  foodAllergies: z.string().max(500).optional(),
  accessibilityNeeds: z.string().max(500).optional(),
});

export const publicRegistrationSchema = z.object({
  leaderFirstName: z.string().trim().min(1, 'Your first name is required').max(100),
  leaderLastName: z.string().trim().min(1, 'Your last name is required').max(100),
  email: z.string().trim().toLowerCase().email('A valid email is required').max(255),
  phone: z.string().trim().max(20).optional(),
  familyConnection: z.string().trim().max(2000).optional(),
  villaTypePreference: z.enum(['standard-2bed', 'standard-3bed', 'host-villa', 'no-preference']),
  flexibilityNotes: z.string().max(500).optional(),
  roomConfigNotes: z.string().max(500).optional(),
  familyMembers: z
    .array(publicRegistrationMemberSchema)
    .min(1, 'At least one family member is required')
    .max(20, 'A maximum of 20 family members is allowed'),
});

export type PublicRegistrationRequest = z.infer<typeof publicRegistrationSchema>;
export type PublicRegistrationMember = z.infer<typeof publicRegistrationMemberSchema>;

export interface PublicRegistrationResponse {
  message: string;
  submissionId?: string;
}

export const PUBLIC_REGISTRATION_ADMIN_NOTE_MARKER = '[public registration submission';
